module.exports = __webpack_public_path__ + "img/qyfw-bg.fa0861ad.png";